import Vue from 'vue';
import Vuex from 'vuex';

import { config } from './config.module';
import { sound } from './sound.module';
import { auth } from './auth.module';
import { trivia } from './trivia.module';
import { shop } from './shop.module';
import { giveaway } from './giveaway.module';
import { superChallenge } from './superChallenge.module';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
	  config, giveaway, sound, auth, trivia, shop, superChallenge
	}
});